import type { StorageThemeKey } from './isStorageThemeKey'
import isStorageThemeKey from './isStorageThemeKey'

export default function getSafeThemeKey(key: string): StorageThemeKey {
  if (!isStorageThemeKey(key)) {
    return 'system'
  }

  return key
}
